import { render, staticRenderFns } from "./CambiarPreinscripcion.vue?vue&type=template&id=4a346040"
import script from "@/components/preinscripcion-update.js?vue&type=script&lang=js&external"
export * from "@/components/preinscripcion-update.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports